import React from 'react'

const GHSymbol = () => {
  return (
    <>&#8373;</>
  )
}

export default GHSymbol;